import React, { useEffect, useState } from "react";
import { DebtDetailsChart } from "../components/DebtDetailsChart";
import { DebtAmortization } from "../components/DebtAmortization";
import { useHistory, useParams } from "react-router-dom";
import debtBackIcon from "../../../assets/images/debtPayoff/backicon.svg";
import { MODULE_API } from "../../../apis";
import { calculateAmortization, generateAmortizationData } from "../../../helpers/amortizationCalcultion";
import moment from "moment";

export const DebtsDetails = () => {
  const history = useHistory();
  const { module } = useParams();
  const { id } = useParams();
  const [loading, setIsLoading] = useState(false);
  const [fieldsData, setFieldsData] = useState(null);
  const [amortizationData, setAmortizationData] = useState(null);
  const [amortizationDataAll, setAmortizationDataAll] = useState(null);

  const amortizationArray = amortizationData ? amortizationData : [];

  const lastEntry =
    amortizationArray && amortizationArray.length > 0
      ? amortizationArray[amortizationArray.length - 1]
      : null;

  // Use cumulative values from the last entry
  const totalCumulativeInterest = lastEntry
    ? parseFloat(lastEntry.cumulativeInterest)
    : 0;

  const totalCumulativePrincipal = lastEntry
    ? parseFloat(lastEntry.cumulativePrincipal)
    : 0;
  const debtCards = [
    {
      id: 1,
      title: "Original Payoff on",
      value:
        lastEntry && lastEntry.date
          ? moment(lastEntry.date).format("MMMM, YYYY")
          : "N/A",
    },
  ];
  const debtTotalCards = [
    {
      id: 1,
      title: "Original Cumulative Interest",
      value: `$${totalCumulativeInterest.toLocaleString(undefined, {
        minimumFractionDigits: 2, maximumFractionDigits: 2,
      })}`,
    },
    {
      id: 2,
      title: "Original Total Paid",
      value: `$${(
        totalCumulativeInterest + totalCumulativePrincipal
      ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2, })}`,
    },
  ];
  // Fetch asset fields data
  const getAssetFieldsData = async (id) => {
    setIsLoading(true);
    try {
      const res = await MODULE_API.fetchSingleGoalDetails(id);
      if (res && res.data) {
        console.log("res.data", res.data);
        const { data } = res;
        if (data.subType === "Credit") {
          const normalizedData = {
            ...data,
            "Nickname of Liabilities": data["Nickname of Credit"] || "",
            "Initial Loan Amount": data["Credit Balance"] || 0,
            "Interest Rate": data["Interest Rate (or APR%)"] || 0,
            "Maturity Date": data["Point Expiration"] || "",
            "Name of Financial Institution": data["Name of Issuer"] || "",
            "Monthly Payment": data["Monthly Payment"]
              ? data["Monthly Payment"].toString()
              : "0",
            "Start Date": new Date(),
            subType: data.subType,
          };

          setFieldsData(normalizedData);
        } else {
          setFieldsData(data);
        }
      }
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (id) {
      getAssetFieldsData(id);
    }
  }, [id]);

  useEffect(() => {
    if (fieldsData) {
      const allAmortizationData = generateAmortizationData({
        liabilitiesData: [fieldsData],
      });
      const { formattedLiabilityData, monthlyPayment }=calculateAmortization(0,fieldsData, module)
      console.log("detailsllslsls", allAmortizationData,formattedLiabilityData);
      setAmortizationDataAll(allAmortizationData)
      setAmortizationData(formattedLiabilityData);
    }
  }, [fieldsData]);

  return (
    <div className="debt-main">
      <div className="debt-create">
        <div
          className="add-debt-section"
          style={{ gap: "8px", cursor: "pointer" }}
          onClick={() => {
            history.push("/debt-payoff");
          }}
        >
          <img src={debtBackIcon} width={16} height={16} alt="back" />
          <div className="addTitle">Debt Details</div>
        </div>
      </div>
      <div className="debt-main-report">
        <div className="debt-card1">
          <h3 className="debt-report-heading-strategy">
            {fieldsData && (
              <img
                src={fieldsData.image}
                width={48}
                style={{ marginRight: "1rem" }}
                alt="liablity"
              ></img>
            )}
            {fieldsData && fieldsData["Nickname of Liabilities"]}
          </h3>
          <div className="debt-row" style={{ height: "75%" }}>
            <div className="debt-image-and-amount-container">
              <div className="debt-strategy-container">
                {debtCards &&
                  debtCards.map((item, index) => (
                    <div
                      key={index}
                      className="debt-strategy-section"
                      style={{ width: "100%" }}
                    >
                      <div className="debt-heading-container">{item.title}</div>
                      <div className="debt-report-amount-section">
                        {item.value}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            <div
              className="debt-image-and-amount-container"
              style={{ marginBottom: "0px" }}
            >
              <div className="debt-strategy-container">
                {debtTotalCards &&
                  debtTotalCards.map((item, index) => (
                    <div key={index} className="debt-strategy-section">
                      <div className="debt-heading-container">{item.title}</div>
                      <div className="debt-report-amount-section">
                        {item.value}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
        <div className="debt-card2" style={{ position: "relative" }}>
          <DebtDetailsChart
            module={module && module}
            amortizationData={amortizationData && amortizationData}
            amortizationDataAll={amortizationDataAll && amortizationDataAll}
            loading={loading}
          />
        </div>
      </div>
      <DebtAmortization
        amortizationData={amortizationData && amortizationData}
        loading={loading}
      />
    </div>
  );
};
